import React from 'react'
import ReactDOM from 'react-dom'
import { Modal, Input } from 'antd'
import lang from '../../../../../languages/en'

import styles from './styles.css'

const deleteConfirmDialog = (onOk) => {
    const onChange = e => {
        if(e.target.value && e.target.value.trim().toUpperCase() === 'YES') {
            modal.update({
                okButtonProps: {
                    disabled: false
                }
            })
        } else {
            modal.update({
                okButtonProps: {
                    disabled: true
                }
            })
        }
    }
    const modal = Modal.confirm({
        title: (
            <div>
                <p>{lang.database_delete_popup_title}</p>
                <p>{lang.database_delete_popup_body}</p>
                <div className="input-wrapper">
                    <Input className="delete-confirm-input" onChange={e => onChange(e)}/>
                </div>
            </div>
        ),
        onOk() {
            onOk && onOk()
        },
        autoFocusButton: null,
        okText: 'Reset Item Master',
        okButtonProps: {
            disabled: true
        },
        className: 'delete-database-modal'
    })
}

export default deleteConfirmDialog



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/deteleConfirmDialog/index.js